import { head, tail, isEmpty, toArray, tryFind, ofArray, find, singleton, empty } from "../fable_modules/fable-library-js.4.19.3/List.js";
import { equals, defaultOf } from "../fable_modules/fable-library-js.4.19.3/Util.js";
import { utcNow, addSeconds, minValue } from "../fable_modules/fable-library-js.4.19.3/DateOffset.js";
import { Model__get_isSegmentationWarningNeeded, Msg, Model } from "./StudyTypes.js";
import { Cmd_map, Cmd_batch, Cmd_none } from "../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { printf, toText } from "../fable_modules/fable-library-js.4.19.3/String.js";
import { map, defaultArg, bind, some } from "../fable_modules/fable-library-js.4.19.3/Option.js";
import { PatientInfo as PatientInfo_1, InternalMsg, InboundMsg as InboundMsg_1, MsgCore, LocalMsg, wrapLocalMsg } from "./CoreForm/CoreFormTypes.js";
import { wrapLocalMsg as wrapLocalMsg_1, wrapInboundMsg } from "../Common/InboundOutbound.js";
import { InboundMsg } from "./CoreForm/CoreFormFileManagement/CoreFormFileTypes.js";
import { OfAsyncWith_result } from "../fable_modules/Fable.Elmish.4.2.0/cmd.obsolete.fs.js";
import { Cmd_OfAsyncWith_either, Cmd_OfAsync_start } from "../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { Async_map } from "../fable_modules/AsyncResult.0.3.0/Result.fs.js";
import { sleep } from "../fable_modules/fable-library-js.4.19.3/Async.js";
import { Navigation_modifyUrl, Navigation_newUrl } from "../fable_modules/Fable.Elmish.Browser.4.0.3/navigation.fs.js";
import { Toast_errorToast, Urls_Page, Urls_PatientPage, Urls_pageHash } from "../Common/General.js";
import { initWithCreate as initWithCreate_1, initWithDisplay as initWithDisplay_1, updateCore } from "./CoreForm/CoreFormState.js";
import { securedApi } from "../Api.js";
import { Common_StudyStatus } from "../RAWMap.Models/Common.js";
import { empty as empty_1, singleton as singleton_1, append, delay as delay_1, toList } from "../fable_modules/fable-library-js.4.19.3/Seq.js";
import { initWithCreate, initWithDisplay, updateAnalysis } from "./AnalysisForm/AnalysisFormState.js";
import { tryPick } from "../fable_modules/fable-library-js.4.19.3/Map.js";
import { updateVisualization, init as init_1 } from "../Visualization/VisualizationState.js";
import { ModelVisualization, VisualizationSubcomponentModel as VisualizationSubcomponentModel_2, InboundMsg as InboundMsg_2 } from "../Visualization/VisualizationTypes.js";
import { MsgAnalysis, InternalMsg as InternalMsg_1, InboundMsg as InboundMsg_3, PatientInfo } from "./AnalysisForm/AnalysisFormTypes.js";
import { ModelStentPlanning__get_hasUnsavedChanges } from "../Visualization/StentPlanning/StentPlanningTypes.js";
import { ModelVisualizationTemp, ModelVisualizationTemp__get_hasModifiedSegmentations } from "../Visualization/VisualizationTemp/VisualizationTempTypes.js";
import { update as update_1, init as init_2 } from "./CustomReport/CustomReportState.js";
import { CustomReportUpdateArgs, CustomReportInitArgs } from "./CustomReport/CustomReportTypes.js";
import { FileManagementUpdateArgs } from "../FileManagement/FileManagementTypes.js";
import { update as update_2, init as init_3 } from "./CustomStentReport/CustomStentReportState.js";
import { CustomStentReportUpdateArgs, CustomStentReportInitArgs } from "./CustomStentReport/CustomStentReportTypes.js";
import { Permission, isAllowed } from "../RAWMap.Models/Security.js";
import { CustomReportViewModel, CustomReportStatus_isNowOutdated_6FCE9E49, CustomReportViewModel_empty_244AC511 } from "../RAWMap.Models/View/CustomReport.js";
import { ErrorMessage_get_describe } from "../RAWMap.Models/ErrorMessage.js";

export function init() {
    return [new Model(undefined, empty(), empty(), empty(), "00000000-0000-0000-0000-000000000000", undefined, undefined, undefined, undefined, false, false, undefined, undefined, undefined, undefined, undefined, undefined, [], defaultOf(), undefined, minValue()), Cmd_none()];
}

export function update(token, msg, model) {
    let msg_3, msg_10, _patientInst, matchValue_2, studyId_1, matchValue_4, msg_33, msg_38, msg_41, msg_43, tupledArg, msg_45, tupledArg_1, text_15, text_16, stentPlanModel, visTempModel, msg_54, msg_66, msg_82, tupledArg_5, msg_92, tupledArg_6, msg_111;
    let matchResult, ex, studyId, commandAfterRefresh, studyGuid, delay, msg_9, runCheck_1, command_1, svm, msg_22, avm, avm_1, avm_2, msg_35, isStentPlanning, selectedStudy, studyId_3, analysis_1, analysis_2, _studyId, msg_47, customReportData, selectedStudy_1, msg_49, data, customReportData_1, selectedStudy_2, msg_51, data_1, studyId_4, data_2, err, studyId_5, data_3, err_1, status, userInfo, cognitoCredentials, s3Context_2, pid, studies, e, sid_3, patientInstitution_1, study_12, patientId, toSelect, toSelect_1, toSelect_2, pid_1, patients, institutions, _mode, _pvm, e_1, e_2;
    switch (msg.tag) {
        case 1: {
            if (msg.fields[0].tag === 0) {
                matchResult = 7;
                msg_22 = msg.fields[0].fields[0];
            }
            else {
                switch (msg.fields[0].fields[0].tag) {
                    case 2: {
                        matchResult = 2;
                        commandAfterRefresh = msg.fields[0].fields[0].fields[0][1];
                        studyGuid = msg.fields[0].fields[0].fields[0][0];
                        break;
                    }
                    case 1: {
                        matchResult = 5;
                        svm = msg.fields[0].fields[0].fields[0];
                        break;
                    }
                    case 3: {
                        matchResult = 6;
                        break;
                    }
                    default: {
                        matchResult = 1;
                        studyId = msg.fields[0].fields[0].fields[0];
                    }
                }
            }
            break;
        }
        case 2: {
            matchResult = 3;
            delay = msg.fields[1];
            msg_9 = msg;
            runCheck_1 = msg.fields[0];
            break;
        }
        case 3: {
            matchResult = 4;
            command_1 = msg.fields[0];
            break;
        }
        case 4: {
            if (msg.fields[0].tag === 0) {
                matchResult = 14;
                msg_35 = msg.fields[0].fields[0];
            }
            else {
                switch (msg.fields[0].fields[0].tag) {
                    case 1: {
                        matchResult = 9;
                        avm_1 = msg.fields[0].fields[0].fields[0];
                        break;
                    }
                    case 2: {
                        matchResult = 10;
                        break;
                    }
                    case 3: {
                        matchResult = 13;
                        break;
                    }
                    case 4: {
                        matchResult = 15;
                        isStentPlanning = msg.fields[0].fields[0].fields[1];
                        selectedStudy = msg.fields[0].fields[0].fields[0];
                        break;
                    }
                    default: {
                        matchResult = 8;
                        avm = msg.fields[0].fields[0].fields[0];
                    }
                }
            }
            break;
        }
        case 5: {
            matchResult = 11;
            avm_2 = msg.fields[0];
            break;
        }
        case 6: {
            if (msg.fields[0].tag === 1) {
                matchResult = 57;
                e_2 = msg.fields[0].fields[0];
            }
            else {
                matchResult = 12;
            }
            break;
        }
        case 7: {
            matchResult = 16;
            studyId_3 = msg.fields[0];
            break;
        }
        case 8: {
            if (msg.fields[0].tag === 1) {
                matchResult = 56;
                e_1 = msg.fields[0].fields[0];
            }
            else if (msg.fields[0].fields[0] == null) {
                matchResult = 18;
            }
            else {
                matchResult = 17;
                analysis_1 = msg.fields[0].fields[0];
            }
            break;
        }
        case 9: {
            matchResult = 19;
            break;
        }
        case 10: {
            matchResult = 20;
            analysis_2 = msg.fields[0];
            break;
        }
        case 11: {
            matchResult = 21;
            _studyId = msg.fields[0];
            break;
        }
        case 12: {
            if (msg.fields[0].tag === 1) {
                switch (msg.fields[0].fields[0].tag) {
                    case 1: {
                        matchResult = 24;
                        customReportData = msg.fields[0].fields[0].fields[1];
                        selectedStudy_1 = msg.fields[0].fields[0].fields[0];
                        break;
                    }
                    case 2: {
                        matchResult = 28;
                        customReportData_1 = msg.fields[0].fields[0].fields[1];
                        selectedStudy_2 = msg.fields[0].fields[0].fields[0];
                        break;
                    }
                    case 3: {
                        matchResult = 39;
                        status = msg.fields[0].fields[0].fields[0];
                        break;
                    }
                    default:
                        matchResult = 23;
                }
            }
            else {
                matchResult = 22;
                msg_47 = msg.fields[0].fields[0];
            }
            break;
        }
        case 13: {
            if (msg.fields[0].tag === 1) {
                switch (msg.fields[0].fields[0].tag) {
                    case 2: {
                        matchResult = 27;
                        break;
                    }
                    case 0: {
                        matchResult = 39;
                        status = msg.fields[0].fields[0].fields[0];
                        break;
                    }
                    default: {
                        matchResult = 26;
                        data = msg.fields[0].fields[0].fields[0];
                    }
                }
            }
            else {
                matchResult = 25;
                msg_49 = msg.fields[0].fields[0];
            }
            break;
        }
        case 14: {
            if (msg.fields[0].tag === 1) {
                if (msg.fields[0].fields[0].tag === 1) {
                    matchResult = 31;
                }
                else {
                    matchResult = 30;
                    data_1 = msg.fields[0].fields[0].fields[0];
                }
            }
            else {
                matchResult = 29;
                msg_51 = msg.fields[0].fields[0];
            }
            break;
        }
        case 15: {
            matchResult = 32;
            studyId_4 = msg.fields[0];
            break;
        }
        case 16: {
            if (msg.fields[0].tag === 1) {
                matchResult = 35;
                err = msg.fields[0].fields[0];
            }
            else if (msg.fields[0].fields[0] == null) {
                matchResult = 34;
            }
            else {
                matchResult = 33;
                data_2 = msg.fields[0].fields[0];
            }
            break;
        }
        case 17: {
            matchResult = 36;
            studyId_5 = msg.fields[0];
            break;
        }
        case 18: {
            if (msg.fields[0].tag === 1) {
                matchResult = 38;
                err_1 = msg.fields[0].fields[0];
            }
            else {
                matchResult = 37;
                data_3 = msg.fields[0].fields[0];
            }
            break;
        }
        case 19: {
            matchResult = 40;
            userInfo = msg.fields[0];
            break;
        }
        case 34: {
            matchResult = 41;
            cognitoCredentials = msg.fields[0];
            s3Context_2 = msg.fields[1];
            break;
        }
        case 20: {
            matchResult = 42;
            pid = msg.fields[0];
            break;
        }
        case 21: {
            if (msg.fields[0].tag === 1) {
                matchResult = 44;
                e = msg.fields[0].fields[0];
            }
            else {
                matchResult = 43;
                studies = msg.fields[0].fields[0];
            }
            break;
        }
        case 29: {
            matchResult = 45;
            sid_3 = msg.fields[0];
            break;
        }
        case 30: {
            matchResult = 46;
            patientInstitution_1 = msg.fields[1];
            study_12 = msg.fields[0];
            break;
        }
        case 31: {
            matchResult = 47;
            patientId = msg.fields[0];
            break;
        }
        case 28: {
            matchResult = 48;
            break;
        }
        case 22: {
            matchResult = 49;
            toSelect = msg.fields[0];
            break;
        }
        case 23: {
            matchResult = 50;
            toSelect_1 = msg.fields[0];
            break;
        }
        case 24: {
            matchResult = 51;
            toSelect_2 = msg.fields[0];
            break;
        }
        case 25: {
            matchResult = 52;
            pid_1 = msg.fields[0];
            break;
        }
        case 32: {
            if (msg.fields[0].tag === 1) {
                matchResult = 57;
                e_2 = msg.fields[0].fields[0];
            }
            else {
                matchResult = 53;
                patients = msg.fields[0].fields[0];
            }
            break;
        }
        case 33: {
            if (msg.fields[0].tag === 1) {
                matchResult = 57;
                e_2 = msg.fields[0].fields[0];
            }
            else {
                matchResult = 54;
                institutions = msg.fields[0].fields[0];
            }
            break;
        }
        case 26: {
            matchResult = 55;
            _mode = msg.fields[1];
            _pvm = msg.fields[0];
            break;
        }
        case 27: {
            if (msg.fields[0].tag === 4) {
                matchResult = 58;
            }
            else {
                matchResult = 59;
            }
            break;
        }
        case 35: {
            matchResult = 60;
            break;
        }
        default: {
            matchResult = 0;
            ex = msg.fields[0];
        }
    }
    switch (matchResult) {
        case 0: {
            console.error(some(toText(printf("Error: %O"))(ex)));
            return [model, Cmd_none()];
        }
        case 1:
            return [new Model(model.MaybeCurrentUser, model.Studies, model.Patients, model.Institutions, model.PatientGuid, model.SelectedPatient, model.PatientInstitution, studyId, model.CoreFormComponent, model.isStudiesLoading, model.isAnalysisLoading, model.AnalysisFormComponent, model.SelectedAnalysis, model.VisualizationComponent, model.CustomReportComponent, model.CustomReportModel, model.CustomStentReportComponent, model.CustomStentReportModels, model.Credentials, model.S3Context, model.SegmentationWarningShownAfter), Cmd_none()];
        case 2: {
            const model$0027 = new Model(model.MaybeCurrentUser, model.Studies, model.Patients, model.Institutions, model.PatientGuid, model.SelectedPatient, model.PatientInstitution, model.StudyGuid, model.CoreFormComponent, true, model.isAnalysisLoading, model.AnalysisFormComponent, model.SelectedAnalysis, model.VisualizationComponent, model.CustomReportComponent, model.CustomReportModel, model.CustomStentReportComponent, model.CustomStentReportModels, model.Credentials, model.S3Context, model.SegmentationWarningShownAfter);
            return [model$0027, Cmd_batch(ofArray([(msg_3 = (new Msg(1, [wrapLocalMsg(new LocalMsg(2, [wrapInboundMsg(new InboundMsg(0, []))]))])), singleton((dispatch) => {
                dispatch(msg_3);
            })), singleton((dispatch_1) => {
                dispatch_1(new Msg(20, [model$0027.PatientGuid]));
            }), singleton((dispatch_2) => {
                dispatch_2(new Msg(2, [(model_1) => {
                    if (model_1.isStudiesLoading) {
                        return undefined;
                    }
                    else {
                        return Cmd_map((arg_1) => (new Msg(1, [new MsgCore(0, [arg_1])])), commandAfterRefresh(find((study) => (study.studyId === studyGuid), model_1.Studies)));
                    }
                }, 1000]));
            })]))];
        }
        case 3: {
            const matchValue = runCheck_1(model);
            if (matchValue == null) {
                return [model, OfAsyncWith_result((x) => {
                    Cmd_OfAsync_start(x);
                }, Async_map(() => msg_9, sleep(delay)))];
            }
            else {
                return [model, (msg_10 = (new Msg(3, [matchValue])), singleton((dispatch_3) => {
                    dispatch_3(msg_10);
                }))];
            }
        }
        case 4:
            return [model, command_1];
        case 5:
            if (model.PatientInstitution != null) {
                if ((_patientInst = model.PatientInstitution, equals(model.StudyGuid, svm.studyId))) {
                    const _patientInst_1 = model.PatientInstitution;
                    return [new Model(model.MaybeCurrentUser, model.Studies, model.Patients, model.Institutions, model.PatientGuid, model.SelectedPatient, model.PatientInstitution, svm.studyId, model.CoreFormComponent, model.isStudiesLoading, model.isAnalysisLoading, model.AnalysisFormComponent, model.SelectedAnalysis, model.VisualizationComponent, model.CustomReportComponent, model.CustomReportModel, model.CustomStentReportComponent, model.CustomStentReportModels, model.Credentials, model.S3Context, model.SegmentationWarningShownAfter), Cmd_batch(ofArray([singleton((dispatch_4) => {
                        dispatch_4(new Msg(20, [model.PatientGuid]));
                    }), singleton((dispatch_5) => {
                        dispatch_5(new Msg(1, [new MsgCore(0, [new InternalMsg(1, [new InboundMsg_1(0, [svm])])])]));
                    })]))];
                }
                else {
                    return [new Model(model.MaybeCurrentUser, model.Studies, model.Patients, model.Institutions, model.PatientGuid, model.SelectedPatient, model.PatientInstitution, svm.studyId, undefined, model.isStudiesLoading, model.isAnalysisLoading, model.AnalysisFormComponent, model.SelectedAnalysis, model.VisualizationComponent, model.CustomReportComponent, model.CustomReportModel, model.CustomStentReportComponent, model.CustomStentReportModels, model.Credentials, model.S3Context, model.SegmentationWarningShownAfter), Cmd_batch(ofArray([singleton((dispatch_6) => {
                        dispatch_6(new Msg(20, [model.PatientGuid]));
                    }), Navigation_newUrl(Urls_pageHash(new Urls_Page(6, [new Urls_PatientPage(2, [[svm.patientId, svm.studyId]])])))]))];
                }
            }
            else {
                return [model, Cmd_batch(ofArray([Toast_errorToast("No patient institution found"), singleton((dispatch_7) => {
                    dispatch_7(new Msg(25, [model.PatientGuid]));
                })]))];
            }
        case 6:
            return [new Model(model.MaybeCurrentUser, model.Studies, model.Patients, model.Institutions, model.PatientGuid, model.SelectedPatient, model.PatientInstitution, model.StudyGuid, undefined, model.isStudiesLoading, model.isAnalysisLoading, model.AnalysisFormComponent, model.SelectedAnalysis, model.VisualizationComponent, model.CustomReportComponent, model.CustomReportModel, model.CustomStentReportComponent, model.CustomStentReportModels, model.Credentials, model.S3Context, model.SegmentationWarningShownAfter), Cmd_batch(ofArray([Navigation_newUrl(Urls_pageHash(new Urls_Page(6, [new Urls_PatientPage(1, [model.PatientGuid])]))), singleton((dispatch_8) => {
                dispatch_8(new Msg(25, [model.PatientGuid]));
            })]))];
        case 7: {
            const matchValue_1 = model.CoreFormComponent;
            if (matchValue_1 == null) {
                let matchResult_1;
                if (msg_22.tag === 0) {
                    if (msg_22.fields[0].tag === 2) {
                        if (msg_22.fields[0].fields[0].tag === 1) {
                            if (msg_22.fields[0].fields[0].fields[0].tag === 4) {
                                matchResult_1 = 0;
                            }
                            else {
                                matchResult_1 = 1;
                            }
                        }
                        else {
                            matchResult_1 = 1;
                        }
                    }
                    else {
                        matchResult_1 = 1;
                    }
                }
                else {
                    matchResult_1 = 1;
                }
                switch (matchResult_1) {
                    case 0:
                        return [model, Cmd_none()];
                    default: {
                        console.error(some(toText(printf("CoreForm does not exist. Message: %A"))(msg_22)));
                        return [model, Toast_errorToast("CoreForm does not exist")];
                    }
                }
            }
            else {
                const patternInput = updateCore(token, msg_22, matchValue_1);
                return [new Model(model.MaybeCurrentUser, model.Studies, model.Patients, model.Institutions, model.PatientGuid, model.SelectedPatient, model.PatientInstitution, model.StudyGuid, patternInput[0], model.isStudiesLoading, model.isAnalysisLoading, model.AnalysisFormComponent, model.SelectedAnalysis, model.VisualizationComponent, model.CustomReportComponent, model.CustomReportModel, model.CustomStentReportComponent, model.CustomStentReportModels, model.Credentials, model.S3Context, model.SegmentationWarningShownAfter), Cmd_map((Item_8) => (new Msg(1, [Item_8])), patternInput[1])];
            }
        }
        case 8: {
            const activeStudy = tryFind((study_1) => (study_1.studyId === avm.studyId), model.Studies);
            let matchResult_2;
            if (activeStudy == null) {
                matchResult_2 = 0;
            }
            else if (activeStudy.status.tag === 4) {
                matchResult_2 = 0;
            }
            else {
                matchResult_2 = 1;
            }
            switch (matchResult_2) {
                case 0:
                    return [new Model(model.MaybeCurrentUser, model.Studies, model.Patients, model.Institutions, model.PatientGuid, model.SelectedPatient, model.PatientInstitution, model.StudyGuid, model.CoreFormComponent, model.isStudiesLoading, model.isAnalysisLoading, undefined, model.SelectedAnalysis, model.VisualizationComponent, model.CustomReportComponent, model.CustomReportModel, model.CustomStentReportComponent, model.CustomStentReportModels, model.Credentials, model.S3Context, model.SegmentationWarningShownAfter), singleton((dispatch_9) => {
                        dispatch_9(new Msg(7, [avm.studyId]));
                    })];
                default:
                    return [model, singleton((dispatch_10) => {
                        dispatch_10(new Msg(5, [avm]));
                    })];
            }
        }
        case 9:
            return [model, singleton((dispatch_11) => {
                dispatch_11(new Msg(5, [avm_1]));
            })];
        case 10:
            return [model, Cmd_batch((matchValue_2 = model.StudyGuid, (matchValue_2 == null) ? singleton(Toast_errorToast("Unable to find selected study")) : ((studyId_1 = matchValue_2, singleton(Cmd_OfAsyncWith_either((x_1) => {
                Cmd_OfAsync_start(x_1);
            }, securedApi(token).updateStudyStatus, [studyId_1, new Common_StudyStatus(3, [])], (Item_11) => (new Msg(6, [Item_11])), (Item_12) => (new Msg(0, [Item_12]))))))))];
        case 11: {
            let studyCmd_1;
            const matchValue_3 = model.StudyGuid;
            if (matchValue_3 == null) {
                studyCmd_1 = singleton(Toast_errorToast("Unable to find selected study"));
            }
            else {
                const studyId_2 = matchValue_3;
                studyCmd_1 = singleton(Cmd_OfAsyncWith_either((x_2) => {
                    Cmd_OfAsync_start(x_2);
                }, securedApi(token).updateStudyStatus, [studyId_2, new Common_StudyStatus(4, [])], (Item_13) => (new Msg(6, [Item_13])), (Item_14) => (new Msg(0, [Item_14]))));
            }
            return [new Model(model.MaybeCurrentUser, model.Studies, model.Patients, model.Institutions, model.PatientGuid, model.SelectedPatient, model.PatientInstitution, model.StudyGuid, model.CoreFormComponent, model.isStudiesLoading, model.isAnalysisLoading, undefined, model.SelectedAnalysis, model.VisualizationComponent, model.CustomReportComponent, model.CustomReportModel, model.CustomStentReportComponent, model.CustomStentReportModels, model.Credentials, model.S3Context, model.SegmentationWarningShownAfter), Cmd_batch(toList(delay_1(() => append(singleton_1(singleton((dispatch_12) => {
                dispatch_12(new Msg(7, [avm_2.studyId]));
            })), delay_1(() => studyCmd_1)))))];
        }
        case 12:
            return [model, singleton((dispatch_13) => {
                dispatch_13(new Msg(20, [model.PatientGuid]));
            })];
        case 13:
            return [new Model(model.MaybeCurrentUser, model.Studies, model.Patients, model.Institutions, model.PatientGuid, model.SelectedPatient, model.PatientInstitution, model.StudyGuid, model.CoreFormComponent, model.isStudiesLoading, model.isAnalysisLoading, undefined, model.SelectedAnalysis, model.VisualizationComponent, model.CustomReportComponent, model.CustomReportModel, model.CustomStentReportComponent, model.CustomStentReportModels, model.Credentials, model.S3Context, model.SegmentationWarningShownAfter), (matchValue_4 = model.SelectedAnalysis, (matchValue_4 != null) ? ((msg_33 = (new Msg(10, [matchValue_4])), singleton((dispatch_14) => {
                dispatch_14(msg_33);
            }))) : Cmd_none())];
        case 14: {
            const matchValue_5 = model.AnalysisFormComponent;
            if (matchValue_5 == null) {
                let matchResult_3;
                if (msg_35.tag === 0) {
                    switch (msg_35.fields[0].tag) {
                        case 3: {
                            if (msg_35.fields[0].fields[0].tag === 0) {
                                if (msg_35.fields[0].fields[0].fields[0].tag === 0) {
                                    if (msg_35.fields[0].fields[0].fields[0].fields[0].tag === 2) {
                                        if (msg_35.fields[0].fields[0].fields[0].fields[0].fields[0].tag === 0) {
                                            if (msg_35.fields[0].fields[0].fields[0].fields[0].fields[0].fields[0].tag === 0) {
                                                if (msg_35.fields[0].fields[0].fields[0].fields[0].fields[0].fields[0].fields[0].tag === 0) {
                                                    matchResult_3 = 0;
                                                }
                                                else {
                                                    matchResult_3 = 1;
                                                }
                                            }
                                            else {
                                                matchResult_3 = 1;
                                            }
                                        }
                                        else {
                                            matchResult_3 = 1;
                                        }
                                    }
                                    else {
                                        matchResult_3 = 1;
                                    }
                                }
                                else {
                                    matchResult_3 = 1;
                                }
                            }
                            else {
                                matchResult_3 = 1;
                            }
                            break;
                        }
                        case 4: {
                            if (msg_35.fields[0].fields[0].tag === 0) {
                                if (msg_35.fields[0].fields[0].fields[0].tag === 0) {
                                    if (msg_35.fields[0].fields[0].fields[0].fields[0].tag === 2) {
                                        if (msg_35.fields[0].fields[0].fields[0].fields[0].fields[0].tag === 0) {
                                            if (msg_35.fields[0].fields[0].fields[0].fields[0].fields[0].fields[0].tag === 0) {
                                                if (msg_35.fields[0].fields[0].fields[0].fields[0].fields[0].fields[0].fields[0].tag === 0) {
                                                    matchResult_3 = 0;
                                                }
                                                else {
                                                    matchResult_3 = 1;
                                                }
                                            }
                                            else {
                                                matchResult_3 = 1;
                                            }
                                        }
                                        else {
                                            matchResult_3 = 1;
                                        }
                                    }
                                    else {
                                        matchResult_3 = 1;
                                    }
                                }
                                else {
                                    matchResult_3 = 1;
                                }
                            }
                            else {
                                matchResult_3 = 1;
                            }
                            break;
                        }
                        default:
                            matchResult_3 = 1;
                    }
                }
                else {
                    matchResult_3 = 1;
                }
                switch (matchResult_3) {
                    case 0:
                        return [model, Cmd_none()];
                    default:
                        return [model, Toast_errorToast("AnalysisForm does not exist")];
                }
            }
            else {
                const patternInput_1 = updateAnalysis(token, msg_35, matchValue_5);
                return [new Model(model.MaybeCurrentUser, model.Studies, model.Patients, model.Institutions, model.PatientGuid, model.SelectedPatient, model.PatientInstitution, model.StudyGuid, model.CoreFormComponent, model.isStudiesLoading, model.isAnalysisLoading, patternInput_1[0], model.SelectedAnalysis, model.VisualizationComponent, model.CustomReportComponent, model.CustomReportModel, model.CustomStentReportComponent, model.CustomStentReportModels, model.Credentials, model.S3Context, model.SegmentationWarningShownAfter), Cmd_map((Item_15) => (new Msg(4, [Item_15])), patternInput_1[1])];
            }
        }
        case 15: {
            const matchValue_6 = model.S3Context;
            const matchValue_7 = model.AnalysisFormComponent;
            const matchValue_8 = model.PatientInstitution;
            const matchValue_9 = model.SelectedPatient;
            const matchValue_10 = bind((i) => i.clinicalDesignation, model.PatientInstitution);
            let matchResult_4, analysisModel, context, patientInstitution, selectedPatient;
            if (matchValue_6 == null) {
                matchResult_4 = 3;
            }
            else if (matchValue_10 != null) {
                if (matchValue_10.tag === 0) {
                    if (isStentPlanning) {
                        matchResult_4 = 0;
                    }
                    else if (matchValue_7 != null) {
                        if (matchValue_8 != null) {
                            if (matchValue_9 != null) {
                                matchResult_4 = 1;
                                analysisModel = matchValue_7;
                                context = matchValue_6;
                                patientInstitution = matchValue_8;
                                selectedPatient = matchValue_9;
                            }
                            else {
                                matchResult_4 = 2;
                            }
                        }
                        else {
                            matchResult_4 = 2;
                        }
                    }
                    else {
                        matchResult_4 = 2;
                    }
                }
                else if (matchValue_7 != null) {
                    if (matchValue_8 != null) {
                        if (matchValue_9 != null) {
                            matchResult_4 = 1;
                            analysisModel = matchValue_7;
                            context = matchValue_6;
                            patientInstitution = matchValue_8;
                            selectedPatient = matchValue_9;
                        }
                        else {
                            matchResult_4 = 2;
                        }
                    }
                    else {
                        matchResult_4 = 2;
                    }
                }
                else {
                    matchResult_4 = 2;
                }
            }
            else if (matchValue_7 != null) {
                if (matchValue_8 != null) {
                    if (matchValue_9 != null) {
                        matchResult_4 = 1;
                        analysisModel = matchValue_7;
                        context = matchValue_6;
                        patientInstitution = matchValue_8;
                        selectedPatient = matchValue_9;
                    }
                    else {
                        matchResult_4 = 2;
                    }
                }
                else {
                    matchResult_4 = 2;
                }
            }
            else {
                matchResult_4 = 2;
            }
            switch (matchResult_4) {
                case 0:
                    return [model, Toast_errorToast("Unable to view stent plan in a research institution, please contact ViTAA support")];
                case 1: {
                    const maybeUiFileManagementVm = tryPick((_arg, vm) => vm, analysisModel.UiDataFileManager.fileUpload.DownloadableFiles);
                    const matchValue_12 = patientInstitution.clinicalDesignation;
                    if (maybeUiFileManagementVm == null) {
                        return [model, Toast_errorToast("Missing Visualization data files, please contact ViTAA support")];
                    }
                    else if (matchValue_12 == null) {
                        return [model, Toast_errorToast("Missing Institution Designation")];
                    }
                    else {
                        const designation = matchValue_12;
                        const uiFileManagementVm = maybeUiFileManagementVm;
                        const patternInput_2 = init_1(context, model.Studies, selectedPatient, selectedStudy, uiFileManagementVm.Name, designation, model.MaybeCurrentUser, isStentPlanning);
                        return [new Model(model.MaybeCurrentUser, model.Studies, model.Patients, model.Institutions, model.PatientGuid, model.SelectedPatient, model.PatientInstitution, model.StudyGuid, model.CoreFormComponent, model.isStudiesLoading, model.isAnalysisLoading, model.AnalysisFormComponent, model.SelectedAnalysis, patternInput_2[0], model.CustomReportComponent, model.CustomReportModel, model.CustomStentReportComponent, model.CustomStentReportModels, model.Credentials, model.S3Context, minValue()), Cmd_batch(ofArray([Cmd_map((arg_5) => (new Msg(12, [wrapLocalMsg_1(arg_5)])), patternInput_2[1]), (msg_38 = (new Msg(12, [wrapInboundMsg(new InboundMsg_2(1, []))])), singleton((dispatch_15) => {
                            dispatch_15(msg_38);
                        }))]))];
                    }
                }
                case 2:
                    return [model, Toast_errorToast("Missing Analysis data, please contact ViTAA support")];
                default:
                    return [model, Toast_errorToast("Missing S3 Context")];
            }
        }
        case 16:
            return [new Model(model.MaybeCurrentUser, model.Studies, model.Patients, model.Institutions, model.PatientGuid, model.SelectedPatient, model.PatientInstitution, model.StudyGuid, model.CoreFormComponent, model.isStudiesLoading, true, model.AnalysisFormComponent, model.SelectedAnalysis, model.VisualizationComponent, model.CustomReportComponent, model.CustomReportModel, model.CustomStentReportComponent, model.CustomStentReportModels, model.Credentials, model.S3Context, model.SegmentationWarningShownAfter), Cmd_OfAsyncWith_either((x_3) => {
                Cmd_OfAsync_start(x_3);
            }, securedApi(token).tryGetAnalysis, studyId_3, (Item_18) => (new Msg(8, [Item_18])), (Item_19) => (new Msg(0, [Item_19])))];
        case 17:
            return [new Model(model.MaybeCurrentUser, model.Studies, model.Patients, model.Institutions, model.PatientGuid, model.SelectedPatient, model.PatientInstitution, model.StudyGuid, model.CoreFormComponent, model.isStudiesLoading, false, model.AnalysisFormComponent, analysis_1, model.VisualizationComponent, model.CustomReportComponent, model.CustomReportModel, model.CustomStentReportComponent, model.CustomStentReportModels, model.Credentials, model.S3Context, model.SegmentationWarningShownAfter), singleton((dispatch_16) => {
                dispatch_16(new Msg(10, [analysis_1]));
            })];
        case 18:
            return [new Model(model.MaybeCurrentUser, model.Studies, model.Patients, model.Institutions, model.PatientGuid, model.SelectedPatient, model.PatientInstitution, model.StudyGuid, model.CoreFormComponent, model.isStudiesLoading, false, model.AnalysisFormComponent, undefined, model.VisualizationComponent, model.CustomReportComponent, model.CustomReportModel, model.CustomStentReportComponent, model.CustomStentReportModels, model.Credentials, model.S3Context, model.SegmentationWarningShownAfter), Cmd_none()];
        case 19: {
            const matchValue_14 = model.StudyGuid;
            if (matchValue_14 == null) {
                return [model, Toast_errorToast("No study selected")];
            }
            else {
                return [model, (msg_41 = (new Msg(11, [matchValue_14])), singleton((dispatch_17) => {
                    dispatch_17(msg_41);
                }))];
            }
        }
        case 20: {
            const activeStudy_1 = tryFind((study_2) => defaultArg(map((activeGuid) => (study_2.studyId === activeGuid), model.StudyGuid), false), model.Studies);
            const userRoles = defaultArg(map((user) => user.roles, model.MaybeCurrentUser), empty());
            const matchValue_15 = model.PatientInstitution;
            const matchValue_16 = model.S3Context;
            if (activeStudy_1 != null) {
                if (matchValue_15 == null) {
                    return [model, Toast_errorToast("No patient institution found.")];
                }
                else if (matchValue_16 == null) {
                    const patInst_1 = matchValue_15;
                    const study_4 = activeStudy_1;
                    const patternInput_4 = initWithDisplay(analysis_2, new PatientInfo(model.PatientGuid, patInst_1), study_4, patInst_1, userRoles);
                    return [new Model(model.MaybeCurrentUser, model.Studies, model.Patients, model.Institutions, model.PatientGuid, model.SelectedPatient, model.PatientInstitution, model.StudyGuid, model.CoreFormComponent, model.isStudiesLoading, model.isAnalysisLoading, patternInput_4[0], model.SelectedAnalysis, model.VisualizationComponent, model.CustomReportComponent, model.CustomReportModel, model.CustomStentReportComponent, model.CustomStentReportModels, model.Credentials, model.S3Context, model.SegmentationWarningShownAfter), Cmd_map((Item_26) => (new Msg(4, [Item_26])), patternInput_4[1])];
                }
                else {
                    const context_1 = matchValue_16;
                    const patInst = matchValue_15;
                    const study_3 = activeStudy_1;
                    const patternInput_3 = initWithDisplay(analysis_2, new PatientInfo(model.PatientGuid, patInst), study_3, patInst, userRoles);
                    return [new Model(model.MaybeCurrentUser, model.Studies, model.Patients, model.Institutions, model.PatientGuid, model.SelectedPatient, model.PatientInstitution, model.StudyGuid, model.CoreFormComponent, model.isStudiesLoading, model.isAnalysisLoading, patternInput_3[0], model.SelectedAnalysis, model.VisualizationComponent, model.CustomReportComponent, model.CustomReportModel, model.CustomStentReportComponent, model.CustomStentReportModels, model.Credentials, model.S3Context, model.SegmentationWarningShownAfter), Cmd_batch(ofArray([Cmd_map((Item_20) => (new Msg(4, [Item_20])), patternInput_3[1]), (msg_43 = (new Msg(4, [new MsgAnalysis(0, [new InternalMsg_1(1, [(tupledArg = [model.Credentials, context_1], new InboundMsg_3(2, [tupledArg[0], tupledArg[1]]))])])])), singleton((dispatch_18) => {
                        dispatch_18(msg_43);
                    }))]))];
                }
            }
            else {
                return [model, Toast_errorToast("No active study found.")];
            }
        }
        case 21: {
            const activeStudy_2 = tryFind((study_5) => defaultArg(map((activeGuid_1) => (study_5.studyId === activeGuid_1), model.StudyGuid), false), model.Studies);
            const userRoles_1 = defaultArg(map((user_1) => user_1.roles, model.MaybeCurrentUser), empty());
            const matchValue_18 = model.PatientInstitution;
            const matchValue_19 = model.S3Context;
            if (activeStudy_2 != null) {
                if (matchValue_18 == null) {
                    return [model, Toast_errorToast("No patient institution found.")];
                }
                else if (matchValue_19 == null) {
                    const patInst_3 = matchValue_18;
                    const study_7 = activeStudy_2;
                    const patternInput_6 = initWithCreate(new PatientInfo(model.PatientGuid, patInst_3), study_7, patInst_3, userRoles_1);
                    return [new Model(model.MaybeCurrentUser, model.Studies, model.Patients, model.Institutions, model.PatientGuid, model.SelectedPatient, model.PatientInstitution, model.StudyGuid, model.CoreFormComponent, model.isStudiesLoading, model.isAnalysisLoading, patternInput_6[0], model.SelectedAnalysis, model.VisualizationComponent, model.CustomReportComponent, model.CustomReportModel, model.CustomStentReportComponent, model.CustomStentReportModels, model.Credentials, model.S3Context, model.SegmentationWarningShownAfter), Cmd_map((Item_33) => (new Msg(4, [Item_33])), patternInput_6[1])];
                }
                else {
                    const context_2 = matchValue_19;
                    const patInst_2 = matchValue_18;
                    const study_6 = activeStudy_2;
                    const patternInput_5 = initWithCreate(new PatientInfo(model.PatientGuid, patInst_2), study_6, patInst_2, userRoles_1);
                    return [new Model(model.MaybeCurrentUser, model.Studies, model.Patients, model.Institutions, model.PatientGuid, model.SelectedPatient, model.PatientInstitution, model.StudyGuid, model.CoreFormComponent, model.isStudiesLoading, model.isAnalysisLoading, patternInput_5[0], model.SelectedAnalysis, model.VisualizationComponent, model.CustomReportComponent, model.CustomReportModel, model.CustomStentReportComponent, model.CustomStentReportModels, model.Credentials, model.S3Context, model.SegmentationWarningShownAfter), Cmd_batch(ofArray([Cmd_map((Item_27) => (new Msg(4, [Item_27])), patternInput_5[1]), (msg_45 = (new Msg(4, [new MsgAnalysis(0, [new InternalMsg_1(1, [(tupledArg_1 = [model.Credentials, context_2], new InboundMsg_3(2, [tupledArg_1[0], tupledArg_1[1]]))])])])), singleton((dispatch_19) => {
                        dispatch_19(msg_45);
                    }))]))];
                }
            }
            else {
                return [model, Toast_errorToast("No active study found.")];
            }
        }
        case 22: {
            const matchValue_21 = model.VisualizationComponent;
            if (matchValue_21 == null) {
                console.warn(some("Visualization component does not exist"));
                return [model, Cmd_none()];
            }
            else {
                const patternInput_7 = updateVisualization(token, msg_47, matchValue_21);
                return [new Model(model.MaybeCurrentUser, model.Studies, model.Patients, model.Institutions, model.PatientGuid, model.SelectedPatient, model.PatientInstitution, model.StudyGuid, model.CoreFormComponent, model.isStudiesLoading, model.isAnalysisLoading, model.AnalysisFormComponent, model.SelectedAnalysis, patternInput_7[0], model.CustomReportComponent, model.CustomReportModel, model.CustomStentReportComponent, model.CustomStentReportModels, model.Credentials, model.S3Context, model.SegmentationWarningShownAfter), Cmd_map((Item_34) => (new Msg(12, [Item_34])), patternInput_7[1])];
            }
        }
        case 23: {
            const matchValue_22 = model.VisualizationComponent;
            if (matchValue_22 != null) {
                const matchValue_23 = matchValue_22.VisualizationSubcomponentModel;
                let matchResult_5, visTempModel_1, stentPlanModel_1;
                if (matchValue_23.tag === 1) {
                    if ((stentPlanModel = matchValue_23.fields[0], (ModelStentPlanning__get_hasUnsavedChanges(stentPlanModel) ? true : stentPlanModel.CanCreateRevision) && !Model__get_isSegmentationWarningNeeded(model))) {
                        matchResult_5 = 1;
                        stentPlanModel_1 = matchValue_23.fields[0];
                    }
                    else {
                        matchResult_5 = 2;
                    }
                }
                else if ((visTempModel = matchValue_23.fields[0], (ModelVisualizationTemp__get_hasModifiedSegmentations(visTempModel) && !Model__get_isSegmentationWarningNeeded(model)) && !visTempModel.ReanalysisSubmitted)) {
                    matchResult_5 = 0;
                    visTempModel_1 = matchValue_23.fields[0];
                }
                else {
                    matchResult_5 = 2;
                }
                switch (matchResult_5) {
                    case 0:
                        return [new Model(model.MaybeCurrentUser, model.Studies, model.Patients, model.Institutions, model.PatientGuid, model.SelectedPatient, model.PatientInstitution, model.StudyGuid, model.CoreFormComponent, model.isStudiesLoading, model.isAnalysisLoading, model.AnalysisFormComponent, model.SelectedAnalysis, model.VisualizationComponent, model.CustomReportComponent, model.CustomReportModel, model.CustomStentReportComponent, model.CustomStentReportModels, model.Credentials, model.S3Context, addSeconds(utcNow(), 10)), (text_15 = "You have unsaved segmentations. Segmentations will be lost if you navigate away. Click Back again to discard changes", Toast_errorToast(text_15))];
                    case 1:
                        return [new Model(model.MaybeCurrentUser, model.Studies, model.Patients, model.Institutions, model.PatientGuid, model.SelectedPatient, model.PatientInstitution, model.StudyGuid, model.CoreFormComponent, model.isStudiesLoading, model.isAnalysisLoading, model.AnalysisFormComponent, model.SelectedAnalysis, model.VisualizationComponent, model.CustomReportComponent, model.CustomReportModel, model.CustomStentReportComponent, model.CustomStentReportModels, model.Credentials, model.S3Context, addSeconds(utcNow(), 10)), (text_16 = "You have unsaved changes. Changes will be lost if you navigate away. Click Back again to discard changes", Toast_errorToast(text_16))];
                    default:
                        return [new Model(model.MaybeCurrentUser, model.Studies, model.Patients, model.Institutions, model.PatientGuid, model.SelectedPatient, model.PatientInstitution, model.StudyGuid, model.CoreFormComponent, model.isStudiesLoading, model.isAnalysisLoading, model.AnalysisFormComponent, model.SelectedAnalysis, undefined, model.CustomReportComponent, model.CustomReportModel, model.CustomStentReportComponent, model.CustomStentReportModels, model.Credentials, model.S3Context, model.SegmentationWarningShownAfter), Cmd_none()];
                }
            }
            else {
                return [new Model(model.MaybeCurrentUser, model.Studies, model.Patients, model.Institutions, model.PatientGuid, model.SelectedPatient, model.PatientInstitution, model.StudyGuid, model.CoreFormComponent, model.isStudiesLoading, model.isAnalysisLoading, model.AnalysisFormComponent, model.SelectedAnalysis, undefined, model.CustomReportComponent, model.CustomReportModel, model.CustomStentReportComponent, model.CustomStentReportModels, model.Credentials, model.S3Context, model.SegmentationWarningShownAfter), Cmd_none()];
            }
        }
        case 24: {
            let matchResult_6, analysis_3, institution, patient, vizComp;
            if (model.SelectedPatient != null) {
                if (model.PatientInstitution != null) {
                    if (model.SelectedAnalysis != null) {
                        if (model.VisualizationComponent != null) {
                            matchResult_6 = 0;
                            analysis_3 = model.SelectedAnalysis;
                            institution = model.PatientInstitution;
                            patient = model.SelectedPatient;
                            vizComp = model.VisualizationComponent;
                        }
                        else {
                            matchResult_6 = 1;
                        }
                    }
                    else {
                        matchResult_6 = 1;
                    }
                }
                else {
                    matchResult_6 = 1;
                }
            }
            else {
                matchResult_6 = 1;
            }
            switch (matchResult_6) {
                case 0: {
                    let updatedVizComp;
                    const matchValue_24 = vizComp.VisualizationSubcomponentModel;
                    if (matchValue_24.tag === 0) {
                        const visTempModel_2 = matchValue_24.fields[0];
                        updatedVizComp = (new ModelVisualization(vizComp.MaybeCurrentUser, vizComp.PatientInstitutionDesignation, vizComp.VisualizationDataFile, vizComp.LoadingStatus, vizComp.ImageData, vizComp.S3Context, vizComp.SelectedStudy, vizComp.SelectedPatientId, vizComp.CurrentStudyAnalysisPipelineVersion, vizComp.MaybePrevStudyAnalysisPipelineVersion, new VisualizationSubcomponentModel_2(0, [new ModelVisualizationTemp(visTempModel_2.MaybeCurrentUser, visTempModel_2.PatientInstitutionDesignation, visTempModel_2.Meshes, visTempModel_2.HasPreviousStudyMaps, visTempModel_2.DisplayPreviousStudyMaps, visTempModel_2.HasCurrentStudyDiametricGrowth, visTempModel_2.CurrentStudyMapDataAvailability, visTempModel_2.MaybePrevStudyMapDataAvailability, visTempModel_2.HasPreviousStudyDiametricGrowth, visTempModel_2.IsFollowupStudy, visTempModel_2.SlicePlaneModel, visTempModel_2.NotesModel, visTempModel_2.CameraModel, visTempModel_2.CalipersModel, visTempModel_2.CenterlineMeasurementModel, visTempModel_2.ScreenshotModel, visTempModel_2.AnatomyOrientationModel, visTempModel_2.PickedMapValueModel, visTempModel_2.S3Context, visTempModel_2.AvailableMaps, visTempModel_2.ViewportSelectedMap, visTempModel_2.PreviousViewportSelectedMap, visTempModel_2.SelectedStudy, visTempModel_2.SelectedPatient, visTempModel_2.ViewMode, visTempModel_2.IsSliceScroll, visTempModel_2.DisplayCenterline, visTempModel_2.InteractionMode, visTempModel_2.Measurements, visTempModel_2.ShowHelpTooltip, visTempModel_2.CurrentStudyAnalysisPipelineVersion, visTempModel_2.MaybePrevStudyAnalysisPipelineVersion, visTempModel_2.CurrentStudyAnalysisRevision, visTempModel_2.CustomReportData, visTempModel_2.ShowMasks, visTempModel_2.SegmentationProps, visTempModel_2.RawThreshold, visTempModel_2.DicomLengthMeasurementIds, visTempModel_2.LengthMeasurementState, visTempModel_2.ActiveSegmentation, visTempModel_2.MaybeActiveWidget, visTempModel_2.ImageLoader, visTempModel_2.ModifiedSegmentations, visTempModel_2.SubmitReanalysisModalVisible, visTempModel_2.ReanalysisSubmitted, visTempModel_2.SegLockWarningShown, visTempModel_2.SegmentationLockWarningModalVisible, false)]), vizComp.ViewportReadyStatusMap, vizComp.MaybeTimeoutId));
                    }
                    else {
                        updatedVizComp = vizComp;
                    }
                    const patternInput_8 = init_2(new CustomReportInitArgs(selectedStudy_1, patient, institution, analysis_3, customReportData.geometryData, customReportData.growthData, customReportData.maybeCurrentStudyAcquisitionDate, customReportData.maybePreviousStudyAcquisitionDate, customReportData.analysisRevision));
                    return [new Model(model.MaybeCurrentUser, model.Studies, model.Patients, model.Institutions, model.PatientGuid, model.SelectedPatient, model.PatientInstitution, model.StudyGuid, model.CoreFormComponent, model.isStudiesLoading, model.isAnalysisLoading, model.AnalysisFormComponent, model.SelectedAnalysis, updatedVizComp, patternInput_8[0], model.CustomReportModel, model.CustomStentReportComponent, model.CustomStentReportModels, model.Credentials, model.S3Context, model.SegmentationWarningShownAfter), Cmd_map((arg_7) => (new Msg(13, [wrapLocalMsg_1(arg_7)])), patternInput_8[1])];
                }
                default:
                    return [model, Toast_errorToast("Unable to create custom report")];
            }
        }
        case 25: {
            const matchValue_25 = model.CustomReportComponent;
            const matchValue_26 = model.S3Context;
            const matchValue_27 = model.CustomReportModel;
            if (matchValue_25 == null) {
                return [model, Cmd_none()];
            }
            else if (matchValue_26 == null) {
                return [model, Toast_errorToast("S3 context does not exist")];
            }
            else if (matchValue_27 == null) {
                return [model, Cmd_none()];
            }
            else {
                const customReportComponent = matchValue_25;
                const customReportModel = matchValue_27;
                const s3Context = matchValue_26;
                const patternInput_9 = update_1(new CustomReportUpdateArgs(customReportModel, new FileManagementUpdateArgs(token, model.Credentials, s3Context), defaultArg(map((user_2) => user_2.roles, model.MaybeCurrentUser), empty())), msg_49, customReportComponent);
                return [new Model(model.MaybeCurrentUser, model.Studies, model.Patients, model.Institutions, model.PatientGuid, model.SelectedPatient, model.PatientInstitution, model.StudyGuid, model.CoreFormComponent, model.isStudiesLoading, model.isAnalysisLoading, model.AnalysisFormComponent, model.SelectedAnalysis, model.VisualizationComponent, patternInput_9[0], model.CustomReportModel, model.CustomStentReportComponent, model.CustomStentReportModels, model.Credentials, model.S3Context, model.SegmentationWarningShownAfter), Cmd_map((Item_37) => (new Msg(13, [Item_37])), patternInput_9[1])];
            }
        }
        case 26:
            return [new Model(model.MaybeCurrentUser, model.Studies, model.Patients, model.Institutions, model.PatientGuid, model.SelectedPatient, model.PatientInstitution, model.StudyGuid, model.CoreFormComponent, model.isStudiesLoading, model.isAnalysisLoading, model.AnalysisFormComponent, model.SelectedAnalysis, model.VisualizationComponent, model.CustomReportComponent, data, model.CustomStentReportComponent, model.CustomStentReportModels, model.Credentials, model.S3Context, model.SegmentationWarningShownAfter), Cmd_none()];
        case 27:
            return [new Model(model.MaybeCurrentUser, model.Studies, model.Patients, model.Institutions, model.PatientGuid, model.SelectedPatient, model.PatientInstitution, model.StudyGuid, model.CoreFormComponent, model.isStudiesLoading, model.isAnalysisLoading, model.AnalysisFormComponent, model.SelectedAnalysis, model.VisualizationComponent, undefined, model.CustomReportModel, model.CustomStentReportComponent, model.CustomStentReportModels, model.Credentials, model.S3Context, model.SegmentationWarningShownAfter), Cmd_none()];
        case 28: {
            let matchResult_7, analysis_4, institution_1, patient_1, vizComp_1;
            if (model.SelectedPatient != null) {
                if (model.PatientInstitution != null) {
                    if (model.SelectedAnalysis != null) {
                        if (model.VisualizationComponent != null) {
                            matchResult_7 = 0;
                            analysis_4 = model.SelectedAnalysis;
                            institution_1 = model.PatientInstitution;
                            patient_1 = model.SelectedPatient;
                            vizComp_1 = model.VisualizationComponent;
                        }
                        else {
                            matchResult_7 = 1;
                        }
                    }
                    else {
                        matchResult_7 = 1;
                    }
                }
                else {
                    matchResult_7 = 1;
                }
            }
            else {
                matchResult_7 = 1;
            }
            switch (matchResult_7) {
                case 0: {
                    let updatedVizComp_1;
                    const matchValue_29 = vizComp_1.VisualizationSubcomponentModel;
                    if (matchValue_29.tag === 0) {
                        const visTempModel_3 = matchValue_29.fields[0];
                        updatedVizComp_1 = (new ModelVisualization(vizComp_1.MaybeCurrentUser, vizComp_1.PatientInstitutionDesignation, vizComp_1.VisualizationDataFile, vizComp_1.LoadingStatus, vizComp_1.ImageData, vizComp_1.S3Context, vizComp_1.SelectedStudy, vizComp_1.SelectedPatientId, vizComp_1.CurrentStudyAnalysisPipelineVersion, vizComp_1.MaybePrevStudyAnalysisPipelineVersion, new VisualizationSubcomponentModel_2(0, [new ModelVisualizationTemp(visTempModel_3.MaybeCurrentUser, visTempModel_3.PatientInstitutionDesignation, visTempModel_3.Meshes, visTempModel_3.HasPreviousStudyMaps, visTempModel_3.DisplayPreviousStudyMaps, visTempModel_3.HasCurrentStudyDiametricGrowth, visTempModel_3.CurrentStudyMapDataAvailability, visTempModel_3.MaybePrevStudyMapDataAvailability, visTempModel_3.HasPreviousStudyDiametricGrowth, visTempModel_3.IsFollowupStudy, visTempModel_3.SlicePlaneModel, visTempModel_3.NotesModel, visTempModel_3.CameraModel, visTempModel_3.CalipersModel, visTempModel_3.CenterlineMeasurementModel, visTempModel_3.ScreenshotModel, visTempModel_3.AnatomyOrientationModel, visTempModel_3.PickedMapValueModel, visTempModel_3.S3Context, visTempModel_3.AvailableMaps, visTempModel_3.ViewportSelectedMap, visTempModel_3.PreviousViewportSelectedMap, visTempModel_3.SelectedStudy, visTempModel_3.SelectedPatient, visTempModel_3.ViewMode, visTempModel_3.IsSliceScroll, visTempModel_3.DisplayCenterline, visTempModel_3.InteractionMode, visTempModel_3.Measurements, visTempModel_3.ShowHelpTooltip, visTempModel_3.CurrentStudyAnalysisPipelineVersion, visTempModel_3.MaybePrevStudyAnalysisPipelineVersion, visTempModel_3.CurrentStudyAnalysisRevision, visTempModel_3.CustomReportData, visTempModel_3.ShowMasks, visTempModel_3.SegmentationProps, visTempModel_3.RawThreshold, visTempModel_3.DicomLengthMeasurementIds, visTempModel_3.LengthMeasurementState, visTempModel_3.ActiveSegmentation, visTempModel_3.MaybeActiveWidget, visTempModel_3.ImageLoader, visTempModel_3.ModifiedSegmentations, visTempModel_3.SubmitReanalysisModalVisible, visTempModel_3.ReanalysisSubmitted, visTempModel_3.SegLockWarningShown, visTempModel_3.SegmentationLockWarningModalVisible, false)]), vizComp_1.ViewportReadyStatusMap, vizComp_1.MaybeTimeoutId));
                    }
                    else {
                        updatedVizComp_1 = vizComp_1;
                    }
                    const patternInput_10 = init_3(new CustomStentReportInitArgs(selectedStudy_2, patient_1, institution_1, analysis_4, customReportData_1.devices, customReportData_1.stentPlanScreenshots, customReportData_1.compositeScreenshots, customReportData_1.maybePatientInfo));
                    return [new Model(model.MaybeCurrentUser, model.Studies, model.Patients, model.Institutions, model.PatientGuid, model.SelectedPatient, model.PatientInstitution, model.StudyGuid, model.CoreFormComponent, model.isStudiesLoading, model.isAnalysisLoading, model.AnalysisFormComponent, model.SelectedAnalysis, updatedVizComp_1, model.CustomReportComponent, model.CustomReportModel, patternInput_10[0], model.CustomStentReportModels, model.Credentials, model.S3Context, model.SegmentationWarningShownAfter), Cmd_map((arg_8) => (new Msg(14, [wrapLocalMsg_1(arg_8)])), patternInput_10[1])];
                }
                default:
                    return [model, Toast_errorToast("Unable to create custom report")];
            }
        }
        case 29: {
            const matchValue_30 = model.CustomStentReportComponent;
            const matchValue_31 = model.S3Context;
            if (matchValue_30 == null) {
                return [model, Cmd_none()];
            }
            else if (matchValue_31 == null) {
                return [model, Toast_errorToast("S3 context does not exist")];
            }
            else {
                const customReportComponent_1 = matchValue_30;
                const s3Context_1 = matchValue_31;
                const patternInput_11 = update_2(new CustomStentReportUpdateArgs(model.CustomStentReportModels, new FileManagementUpdateArgs(token, model.Credentials, s3Context_1), defaultArg(map((user_3) => user_3.roles, model.MaybeCurrentUser), empty())), msg_51, customReportComponent_1);
                return [new Model(model.MaybeCurrentUser, model.Studies, model.Patients, model.Institutions, model.PatientGuid, model.SelectedPatient, model.PatientInstitution, model.StudyGuid, model.CoreFormComponent, model.isStudiesLoading, model.isAnalysisLoading, model.AnalysisFormComponent, model.SelectedAnalysis, model.VisualizationComponent, model.CustomReportComponent, model.CustomReportModel, patternInput_11[0], model.CustomStentReportModels, model.Credentials, model.S3Context, model.SegmentationWarningShownAfter), Cmd_map((Item_40) => (new Msg(14, [Item_40])), patternInput_11[1])];
            }
        }
        case 30:
            return [model, singleton((dispatch_20) => {
                dispatch_20(new Msg(17, [data_1.studyId]));
            })];
        case 31:
            return [new Model(model.MaybeCurrentUser, model.Studies, model.Patients, model.Institutions, model.PatientGuid, model.SelectedPatient, model.PatientInstitution, model.StudyGuid, model.CoreFormComponent, model.isStudiesLoading, model.isAnalysisLoading, model.AnalysisFormComponent, model.SelectedAnalysis, model.VisualizationComponent, model.CustomReportComponent, model.CustomReportModel, undefined, model.CustomStentReportModels, model.Credentials, model.S3Context, model.SegmentationWarningShownAfter), Cmd_none()];
        case 32:
            if (defaultArg(map((user_4) => isAllowed(new Permission(20, []))(user_4.roles), model.MaybeCurrentUser), false)) {
                return [new Model(model.MaybeCurrentUser, model.Studies, model.Patients, model.Institutions, model.PatientGuid, model.SelectedPatient, model.PatientInstitution, model.StudyGuid, model.CoreFormComponent, model.isStudiesLoading, model.isAnalysisLoading, model.AnalysisFormComponent, model.SelectedAnalysis, model.VisualizationComponent, model.CustomReportComponent, CustomReportViewModel_empty_244AC511(studyId_4), model.CustomStentReportComponent, model.CustomStentReportModels, model.Credentials, model.S3Context, model.SegmentationWarningShownAfter), Cmd_OfAsyncWith_either((x_4) => {
                    Cmd_OfAsync_start(x_4);
                }, securedApi(token).getCustomReport, studyId_4, (Item_41) => (new Msg(16, [Item_41])), (Item_42) => (new Msg(0, [Item_42])))];
            }
            else {
                return [model, Cmd_none()];
            }
        case 33:
            return [new Model(model.MaybeCurrentUser, model.Studies, model.Patients, model.Institutions, model.PatientGuid, model.SelectedPatient, model.PatientInstitution, model.StudyGuid, model.CoreFormComponent, model.isStudiesLoading, model.isAnalysisLoading, model.AnalysisFormComponent, model.SelectedAnalysis, model.VisualizationComponent, model.CustomReportComponent, data_2, model.CustomStentReportComponent, model.CustomStentReportModels, model.Credentials, model.S3Context, model.SegmentationWarningShownAfter), Cmd_none()];
        case 34:
            return [model, Cmd_none()];
        case 35:
            return [model, Toast_errorToast(ErrorMessage_get_describe()(err))];
        case 36:
            if (defaultArg(map((user_5) => isAllowed(new Permission(20, []))(user_5.roles), model.MaybeCurrentUser), false)) {
                return [new Model(model.MaybeCurrentUser, model.Studies, model.Patients, model.Institutions, model.PatientGuid, model.SelectedPatient, model.PatientInstitution, model.StudyGuid, model.CoreFormComponent, model.isStudiesLoading, model.isAnalysisLoading, model.AnalysisFormComponent, model.SelectedAnalysis, model.VisualizationComponent, model.CustomReportComponent, model.CustomReportModel, model.CustomStentReportComponent, [], model.Credentials, model.S3Context, model.SegmentationWarningShownAfter), Cmd_OfAsyncWith_either((x_5) => {
                    Cmd_OfAsync_start(x_5);
                }, securedApi(token).getCustomStentReportsForStudy, studyId_5, (Item_43) => (new Msg(18, [Item_43])), (Item_44) => (new Msg(0, [Item_44])))];
            }
            else {
                return [model, Cmd_none()];
            }
        case 37:
            return [new Model(model.MaybeCurrentUser, model.Studies, model.Patients, model.Institutions, model.PatientGuid, model.SelectedPatient, model.PatientInstitution, model.StudyGuid, model.CoreFormComponent, model.isStudiesLoading, model.isAnalysisLoading, model.AnalysisFormComponent, model.SelectedAnalysis, model.VisualizationComponent, model.CustomReportComponent, model.CustomReportModel, model.CustomStentReportComponent, toArray(data_3), model.Credentials, model.S3Context, model.SegmentationWarningShownAfter), Cmd_none()];
        case 38:
            return [model, Toast_errorToast(ErrorMessage_get_describe()(err_1))];
        case 39:
            return [new Model(model.MaybeCurrentUser, model.Studies, model.Patients, model.Institutions, model.PatientGuid, model.SelectedPatient, model.PatientInstitution, model.StudyGuid, model.CoreFormComponent, model.isStudiesLoading, model.isAnalysisLoading, model.AnalysisFormComponent, model.SelectedAnalysis, model.VisualizationComponent, model.CustomReportComponent, map((crm) => (new CustomReportViewModel(crm.studyId, crm.maybeConclusion, crm.maybeLastReportPath, crm.maybeLastReportDate, CustomReportStatus_isNowOutdated_6FCE9E49(crm.maybeLastReportOutdated)(status))), model.CustomReportModel), model.CustomStentReportComponent, model.CustomStentReportModels, model.Credentials, model.S3Context, model.SegmentationWarningShownAfter), Cmd_none()];
        case 40: {
            const model_2 = new Model(userInfo, model.Studies, model.Patients, model.Institutions, model.PatientGuid, model.SelectedPatient, model.PatientInstitution, model.StudyGuid, model.CoreFormComponent, model.isStudiesLoading, model.isAnalysisLoading, model.AnalysisFormComponent, model.SelectedAnalysis, model.VisualizationComponent, model.CustomReportComponent, model.CustomReportModel, model.CustomStentReportComponent, model.CustomStentReportModels, model.Credentials, model.S3Context, model.SegmentationWarningShownAfter);
            if (model_2.StudyGuid != null) {
                return [model_2, (msg_54 = (new Msg(29, [model_2.StudyGuid])), singleton((dispatch_21) => {
                    dispatch_21(msg_54);
                }))];
            }
            else {
                return [model_2, Cmd_none()];
            }
        }
        case 41:
            return [new Model(model.MaybeCurrentUser, model.Studies, model.Patients, model.Institutions, model.PatientGuid, model.SelectedPatient, model.PatientInstitution, model.StudyGuid, model.CoreFormComponent, model.isStudiesLoading, model.isAnalysisLoading, model.AnalysisFormComponent, model.SelectedAnalysis, model.VisualizationComponent, model.CustomReportComponent, model.CustomReportModel, model.CustomStentReportComponent, model.CustomStentReportModels, cognitoCredentials, s3Context_2, model.SegmentationWarningShownAfter), Cmd_batch(toList(delay_1(() => {
                let msg_56, tupledArg_2;
                return append((model.CoreFormComponent != null) ? singleton_1((msg_56 = (new Msg(1, [new MsgCore(0, [new InternalMsg(1, [(tupledArg_2 = [cognitoCredentials, s3Context_2], new InboundMsg_1(1, [tupledArg_2[0], tupledArg_2[1]]))])])])), singleton((dispatch_22) => {
                    dispatch_22(msg_56);
                }))) : empty_1(), delay_1(() => {
                    let msg_58, tupledArg_3;
                    return append((model.AnalysisFormComponent != null) ? singleton_1((msg_58 = (new Msg(4, [new MsgAnalysis(0, [new InternalMsg_1(1, [(tupledArg_3 = [cognitoCredentials, s3Context_2], new InboundMsg_3(2, [tupledArg_3[0], tupledArg_3[1]]))])])])), singleton((dispatch_23) => {
                        dispatch_23(msg_58);
                    }))) : empty_1(), delay_1(() => {
                        let msg_61, tupledArg_4;
                        return (model.VisualizationComponent != null) ? singleton_1((msg_61 = (new Msg(12, [wrapInboundMsg((tupledArg_4 = [cognitoCredentials, s3Context_2], new InboundMsg_2(0, [tupledArg_4[0], tupledArg_4[1]])))])), singleton((dispatch_24) => {
                            dispatch_24(msg_61);
                        }))) : empty_1();
                    }));
                }));
            })))];
        case 42:
            return [new Model(model.MaybeCurrentUser, model.Studies, model.Patients, model.Institutions, pid, model.SelectedPatient, model.PatientInstitution, model.StudyGuid, model.CoreFormComponent, true, model.isAnalysisLoading, model.AnalysisFormComponent, model.SelectedAnalysis, model.VisualizationComponent, model.CustomReportComponent, model.CustomReportModel, model.CustomStentReportComponent, model.CustomStentReportModels, model.Credentials, model.S3Context, model.SegmentationWarningShownAfter), Cmd_OfAsyncWith_either((x_6) => {
                Cmd_OfAsync_start(x_6);
            }, securedApi(token).getPatientStudies, model.PatientGuid, (Item_58) => (new Msg(21, [Item_58])), (Item_59) => (new Msg(0, [Item_59])))];
        case 43: {
            const model_3 = new Model(model.MaybeCurrentUser, studies, model.Patients, model.Institutions, model.PatientGuid, model.SelectedPatient, model.PatientInstitution, model.StudyGuid, model.CoreFormComponent, false, model.isAnalysisLoading, model.AnalysisFormComponent, model.SelectedAnalysis, model.VisualizationComponent, model.CustomReportComponent, model.CustomReportModel, model.CustomStentReportComponent, model.CustomStentReportModels, model.Credentials, model.S3Context, model.SegmentationWarningShownAfter);
            let matchResult_8, sid_1, sid_2, patient_2;
            if (model_3.StudyGuid != null) {
                if (model_3.CoreFormComponent == null) {
                    matchResult_8 = 1;
                    sid_2 = model_3.StudyGuid;
                }
                else {
                    matchResult_8 = 0;
                    sid_1 = model_3.StudyGuid;
                }
            }
            else if (model_3.CoreFormComponent != null) {
                if (model_3.CoreFormComponent.Mode.tag === 1) {
                    matchResult_8 = 2;
                }
                else if (model_3.SelectedPatient != null) {
                    matchResult_8 = 3;
                    patient_2 = model_3.SelectedPatient;
                }
                else {
                    matchResult_8 = 4;
                }
            }
            else if (model_3.SelectedPatient != null) {
                matchResult_8 = 3;
                patient_2 = model_3.SelectedPatient;
            }
            else {
                matchResult_8 = 4;
            }
            switch (matchResult_8) {
                case 0: {
                    const updatedStudy = tryFind((study_8) => (study_8.studyId === sid_1), studies);
                    if (updatedStudy == null) {
                        return [new Model(model_3.MaybeCurrentUser, studies, model_3.Patients, model_3.Institutions, model_3.PatientGuid, model_3.SelectedPatient, model_3.PatientInstitution, model_3.StudyGuid, model_3.CoreFormComponent, model_3.isStudiesLoading, model_3.isAnalysisLoading, model_3.AnalysisFormComponent, model_3.SelectedAnalysis, model_3.VisualizationComponent, model_3.CustomReportComponent, model_3.CustomReportModel, model_3.CustomStentReportComponent, model_3.CustomStentReportModels, model_3.Credentials, model_3.S3Context, model_3.SegmentationWarningShownAfter), Cmd_none()];
                    }
                    else {
                        const study_9 = updatedStudy;
                        const maybeAnalysisCommand = (model_3.AnalysisFormComponent != null) ? singleton(singleton((dispatch_25) => {
                            dispatch_25(new Msg(4, [new MsgAnalysis(0, [new InternalMsg_1(1, [new InboundMsg_3(1, [study_9])])])]));
                        })) : empty();
                        const maybeVisualizationCommand = (model_3.VisualizationComponent != null) ? singleton((msg_66 = (new Msg(12, [wrapInboundMsg(new InboundMsg_2(2, [study_9]))])), singleton((dispatch_26) => {
                            dispatch_26(msg_66);
                        }))) : empty();
                        return [model_3, Cmd_batch(toList(delay_1(() => append(singleton_1(singleton((dispatch_27) => {
                            dispatch_27(new Msg(1, [new MsgCore(0, [new InternalMsg(1, [new InboundMsg_1(0, [study_9])])])]));
                        })), delay_1(() => {
                            let msg_72;
                            return append(singleton_1((msg_72 = (new Msg(1, [wrapLocalMsg(new LocalMsg(2, [wrapInboundMsg(new InboundMsg(1, [study_9.status]))]))])), singleton((dispatch_28) => {
                                dispatch_28(msg_72);
                            }))), delay_1(() => append(maybeAnalysisCommand, delay_1(() => maybeVisualizationCommand))));
                        })))))];
                    }
                }
                case 1:
                    return [model_3, singleton((dispatch_29) => {
                        dispatch_29(new Msg(29, [sid_2]));
                    })];
                case 2:
                    return [model_3, Cmd_none()];
                case 3:
                    return [new Model(model_3.MaybeCurrentUser, studies, model_3.Patients, model_3.Institutions, model_3.PatientGuid, model_3.SelectedPatient, model_3.PatientInstitution, model_3.StudyGuid, model_3.CoreFormComponent, model_3.isStudiesLoading, model_3.isAnalysisLoading, model_3.AnalysisFormComponent, model_3.SelectedAnalysis, model_3.VisualizationComponent, model_3.CustomReportComponent, model_3.CustomReportModel, model_3.CustomStentReportComponent, model_3.CustomStentReportModels, model_3.Credentials, model_3.S3Context, model_3.SegmentationWarningShownAfter), singleton((dispatch_30) => {
                        dispatch_30(new Msg(24, [patient_2.id]));
                    })];
                default:
                    return [model_3, Cmd_none()];
            }
        }
        case 44:
            return [new Model(model.MaybeCurrentUser, model.Studies, model.Patients, model.Institutions, model.PatientGuid, model.SelectedPatient, model.PatientInstitution, model.StudyGuid, model.CoreFormComponent, false, model.isAnalysisLoading, model.AnalysisFormComponent, model.SelectedAnalysis, model.VisualizationComponent, model.CustomReportComponent, model.CustomReportModel, model.CustomStentReportComponent, model.CustomStentReportModels, model.Credentials, model.S3Context, model.SegmentationWarningShownAfter), Toast_errorToast(ErrorMessage_get_describe()(e))];
        case 45: {
            const updatedStudy_1 = tryFind((study_10) => (study_10.studyId === sid_3), model.Studies);
            let matchResult_9, _userInfo, patientInst, study_11;
            if (model.MaybeCurrentUser != null) {
                if (model.PatientInstitution != null) {
                    if (updatedStudy_1 != null) {
                        matchResult_9 = 0;
                        _userInfo = model.MaybeCurrentUser;
                        patientInst = model.PatientInstitution;
                        study_11 = updatedStudy_1;
                    }
                    else {
                        matchResult_9 = 1;
                    }
                }
                else {
                    matchResult_9 = 1;
                }
            }
            else {
                matchResult_9 = 1;
            }
            switch (matchResult_9) {
                case 0:
                    return [model, Cmd_batch(ofArray([singleton((dispatch_31) => {
                        dispatch_31(new Msg(30, [study_11, patientInst]));
                    }), singleton((dispatch_32) => {
                        dispatch_32(new Msg(7, [sid_3]));
                    })]))];
                default:
                    return [model, Cmd_none()];
            }
        }
        case 46: {
            const matchValue_34 = model.S3Context;
            const matchValue_35 = model.MaybeCurrentUser;
            let matchResult_10, context_3, role, role_1;
            if (matchValue_34 == null) {
                if (matchValue_35 != null) {
                    if (!isEmpty(matchValue_35.roles)) {
                        if (isEmpty(tail(matchValue_35.roles))) {
                            matchResult_10 = 1;
                            role_1 = head(matchValue_35.roles);
                        }
                        else {
                            matchResult_10 = 2;
                        }
                    }
                    else {
                        matchResult_10 = 2;
                    }
                }
                else {
                    matchResult_10 = 2;
                }
            }
            else if (matchValue_35 != null) {
                if (!isEmpty(matchValue_35.roles)) {
                    if (isEmpty(tail(matchValue_35.roles))) {
                        matchResult_10 = 0;
                        context_3 = matchValue_34;
                        role = head(matchValue_35.roles);
                    }
                    else {
                        matchResult_10 = 2;
                    }
                }
                else {
                    matchResult_10 = 2;
                }
            }
            else {
                matchResult_10 = 2;
            }
            switch (matchResult_10) {
                case 0: {
                    const patternInput_12 = initWithDisplay_1(model.CoreFormComponent, study_12, patientInstitution_1, role);
                    return [new Model(model.MaybeCurrentUser, model.Studies, model.Patients, model.Institutions, model.PatientGuid, model.SelectedPatient, model.PatientInstitution, model.StudyGuid, patternInput_12[0], model.isStudiesLoading, model.isAnalysisLoading, model.AnalysisFormComponent, model.SelectedAnalysis, model.VisualizationComponent, model.CustomReportComponent, model.CustomReportModel, model.CustomStentReportComponent, model.CustomStentReportModels, model.Credentials, model.S3Context, model.SegmentationWarningShownAfter), Cmd_batch(ofArray([Cmd_map((Item_73) => (new Msg(1, [Item_73])), patternInput_12[1]), (msg_82 = (new Msg(1, [new MsgCore(0, [new InternalMsg(1, [(tupledArg_5 = [model.Credentials, context_3], new InboundMsg_1(1, [tupledArg_5[0], tupledArg_5[1]]))])])])), singleton((dispatch_33) => {
                        dispatch_33(msg_82);
                    })), singleton((dispatch_34) => {
                        dispatch_34(new Msg(15, [study_12.studyId]));
                    }), singleton((dispatch_35) => {
                        dispatch_35(new Msg(17, [study_12.studyId]));
                    })]))];
                }
                case 1: {
                    const patternInput_13 = initWithDisplay_1(model.CoreFormComponent, study_12, patientInstitution_1, role_1);
                    return [new Model(model.MaybeCurrentUser, model.Studies, model.Patients, model.Institutions, model.PatientGuid, model.SelectedPatient, model.PatientInstitution, model.StudyGuid, patternInput_13[0], model.isStudiesLoading, model.isAnalysisLoading, model.AnalysisFormComponent, model.SelectedAnalysis, model.VisualizationComponent, model.CustomReportComponent, model.CustomReportModel, model.CustomStentReportComponent, model.CustomStentReportModels, model.Credentials, model.S3Context, model.SegmentationWarningShownAfter), Cmd_batch(ofArray([Cmd_map((Item_79) => (new Msg(1, [Item_79])), patternInput_13[1]), singleton((dispatch_36) => {
                        dispatch_36(new Msg(15, [study_12.studyId]));
                    }), singleton((dispatch_37) => {
                        dispatch_37(new Msg(17, [study_12.studyId]));
                    })]))];
                }
                default:
                    return [model, Toast_errorToast("No user role found.")];
            }
        }
        case 47: {
            const matchValue_37 = model.PatientInstitution;
            const matchValue_38 = model.S3Context;
            const matchValue_39 = model.MaybeCurrentUser;
            let matchResult_11, context_4, patInst_4, role_2, patInst_5, role_3;
            if (matchValue_37 == null) {
                if (matchValue_39 != null) {
                    if (!isEmpty(matchValue_39.roles)) {
                        if (isEmpty(tail(matchValue_39.roles))) {
                            matchResult_11 = 2;
                        }
                        else {
                            matchResult_11 = 3;
                        }
                    }
                    else {
                        matchResult_11 = 3;
                    }
                }
                else {
                    matchResult_11 = 3;
                }
            }
            else if (matchValue_38 == null) {
                if (matchValue_39 != null) {
                    if (!isEmpty(matchValue_39.roles)) {
                        if (isEmpty(tail(matchValue_39.roles))) {
                            matchResult_11 = 1;
                            patInst_5 = matchValue_37;
                            role_3 = head(matchValue_39.roles);
                        }
                        else {
                            matchResult_11 = 3;
                        }
                    }
                    else {
                        matchResult_11 = 3;
                    }
                }
                else {
                    matchResult_11 = 3;
                }
            }
            else if (matchValue_39 != null) {
                if (!isEmpty(matchValue_39.roles)) {
                    if (isEmpty(tail(matchValue_39.roles))) {
                        matchResult_11 = 0;
                        context_4 = matchValue_38;
                        patInst_4 = matchValue_37;
                        role_2 = head(matchValue_39.roles);
                    }
                    else {
                        matchResult_11 = 3;
                    }
                }
                else {
                    matchResult_11 = 3;
                }
            }
            else {
                matchResult_11 = 3;
            }
            switch (matchResult_11) {
                case 0: {
                    const patternInput_14 = initWithCreate_1(new PatientInfo_1(patientId, patInst_4), model.Studies, role_2);
                    return [new Model(model.MaybeCurrentUser, model.Studies, model.Patients, model.Institutions, model.PatientGuid, model.SelectedPatient, model.PatientInstitution, undefined, patternInput_14[0], model.isStudiesLoading, model.isAnalysisLoading, model.AnalysisFormComponent, model.SelectedAnalysis, model.VisualizationComponent, model.CustomReportComponent, model.CustomReportModel, model.CustomStentReportComponent, model.CustomStentReportModels, model.Credentials, model.S3Context, model.SegmentationWarningShownAfter), Cmd_batch(ofArray([Navigation_modifyUrl(Urls_pageHash(new Urls_Page(6, [new Urls_PatientPage(1, [patientId])]))), Cmd_map((Item_80) => (new Msg(1, [Item_80])), patternInput_14[1]), (msg_92 = (new Msg(1, [new MsgCore(0, [new InternalMsg(1, [(tupledArg_6 = [model.Credentials, context_4], new InboundMsg_1(1, [tupledArg_6[0], tupledArg_6[1]]))])])])), singleton((dispatch_38) => {
                        dispatch_38(msg_92);
                    }))]))];
                }
                case 1: {
                    const patternInput_15 = initWithCreate_1(new PatientInfo_1(patientId, patInst_5), model.Studies, role_3);
                    return [new Model(model.MaybeCurrentUser, model.Studies, model.Patients, model.Institutions, model.PatientGuid, model.SelectedPatient, model.PatientInstitution, undefined, patternInput_15[0], model.isStudiesLoading, model.isAnalysisLoading, model.AnalysisFormComponent, model.SelectedAnalysis, model.VisualizationComponent, model.CustomReportComponent, model.CustomReportModel, model.CustomStentReportComponent, model.CustomStentReportModels, model.Credentials, model.S3Context, model.SegmentationWarningShownAfter), Cmd_batch(ofArray([Navigation_modifyUrl(Urls_pageHash(new Urls_Page(6, [new Urls_PatientPage(1, [patientId])]))), Cmd_map((Item_86) => (new Msg(1, [Item_86])), patternInput_15[1])]))];
                }
                case 2:
                    return [model, Toast_errorToast("No patient institution found.")];
                default:
                    return [model, Toast_errorToast("No user role found.")];
            }
        }
        case 48:
            return [model, singleton((dispatch_39) => {
                dispatch_39(new Msg(31, [model.PatientGuid]));
            })];
        case 49: {
            const model_4 = new Model(model.MaybeCurrentUser, model.Studies, model.Patients, model.Institutions, model.PatientGuid, model.SelectedPatient, model.PatientInstitution, toSelect, model.CoreFormComponent, model.isStudiesLoading, model.isAnalysisLoading, model.AnalysisFormComponent, model.SelectedAnalysis, model.VisualizationComponent, model.CustomReportComponent, model.CustomReportModel, model.CustomStentReportComponent, model.CustomStentReportModels, model.Credentials, model.S3Context, model.SegmentationWarningShownAfter);
            return [model_4, Cmd_batch(ofArray([singleton((dispatch_40) => {
                dispatch_40(new Msg(29, [toSelect]));
            }), singleton((dispatch_41) => {
                dispatch_41(new Msg(24, [model_4.PatientGuid]));
            })]))];
        }
        case 50: {
            let matchResult_12;
            if (model.CoreFormComponent != null) {
                switch (model.CoreFormComponent.Mode.tag) {
                    case 1:
                    case 2: {
                        matchResult_12 = 0;
                        break;
                    }
                    default:
                        if (model.AnalysisFormComponent != null) {
                            switch (model.AnalysisFormComponent.Mode.tag) {
                                case 1:
                                case 2: {
                                    matchResult_12 = 0;
                                    break;
                                }
                                default:
                                    matchResult_12 = 1;
                            }
                        }
                        else {
                            matchResult_12 = 1;
                        }
                }
            }
            else if (model.AnalysisFormComponent != null) {
                switch (model.AnalysisFormComponent.Mode.tag) {
                    case 1:
                    case 2: {
                        matchResult_12 = 0;
                        break;
                    }
                    default:
                        matchResult_12 = 1;
                }
            }
            else {
                matchResult_12 = 1;
            }
            switch (matchResult_12) {
                case 0:
                    return [model, Toast_errorToast("Study modification is in progress. Please complete or cancel to navigate away.")];
                default:
                    return [new Model(model.MaybeCurrentUser, model.Studies, model.Patients, model.Institutions, model.PatientGuid, model.SelectedPatient, model.PatientInstitution, toSelect_1.studyId, model.CoreFormComponent, model.isStudiesLoading, model.isAnalysisLoading, model.AnalysisFormComponent, model.SelectedAnalysis, model.VisualizationComponent, model.CustomReportComponent, model.CustomReportModel, model.CustomStentReportComponent, model.CustomStentReportModels, model.Credentials, model.S3Context, model.SegmentationWarningShownAfter), Cmd_batch(singleton(Navigation_newUrl(Urls_pageHash(new Urls_Page(6, [new Urls_PatientPage(2, [[toSelect_1.patientId, toSelect_1.studyId]])])))))];
            }
        }
        case 51: {
            const studyPatient = tryFind((patient_3) => (patient_3.id === toSelect_2), model.Patients);
            const model_5 = new Model(model.MaybeCurrentUser, model.Studies, model.Patients, model.Institutions, toSelect_2, studyPatient, bind((patient_4) => tryFind((inst) => (inst.id === patient_4.institutionId), model.Institutions), studyPatient), model.StudyGuid, model.CoreFormComponent, model.isStudiesLoading, model.isAnalysisLoading, model.AnalysisFormComponent, model.SelectedAnalysis, model.VisualizationComponent, model.CustomReportComponent, model.CustomReportModel, model.CustomStentReportComponent, model.CustomStentReportModels, model.Credentials, model.S3Context, model.SegmentationWarningShownAfter);
            const matchValue_41 = model_5.StudyGuid;
            if (matchValue_41 != null) {
                if (model_5.CoreFormComponent == null) {
                    const studyId_6 = matchValue_41;
                    return [model_5, singleton((dispatch_42) => {
                        dispatch_42(new Msg(29, [studyId_6]));
                    })];
                }
                else {
                    return [model_5, Cmd_none()];
                }
            }
            else {
                return [new Model(model_5.MaybeCurrentUser, model_5.Studies, model_5.Patients, model_5.Institutions, model_5.PatientGuid, model_5.SelectedPatient, model_5.PatientInstitution, model_5.StudyGuid, undefined, model_5.isStudiesLoading, model_5.isAnalysisLoading, model_5.AnalysisFormComponent, model_5.SelectedAnalysis, model_5.VisualizationComponent, model_5.CustomReportComponent, model_5.CustomReportModel, model_5.CustomStentReportComponent, model_5.CustomStentReportModels, model_5.Credentials, model_5.S3Context, model_5.SegmentationWarningShownAfter), Cmd_none()];
            }
        }
        case 52:
            return [new Model(model.MaybeCurrentUser, empty(), model.Patients, model.Institutions, pid_1, undefined, undefined, undefined, undefined, false, false, undefined, undefined, undefined, undefined, undefined, undefined, [], model.Credentials, model.S3Context, minValue()), Cmd_batch(ofArray([singleton((dispatch_43) => {
                dispatch_43(new Msg(20, [pid_1]));
            }), singleton((dispatch_44) => {
                dispatch_44(new Msg(24, [pid_1]));
            })]))];
        case 53:
            return [new Model(model.MaybeCurrentUser, model.Studies, patients, model.Institutions, model.PatientGuid, model.SelectedPatient, model.PatientInstitution, model.StudyGuid, model.CoreFormComponent, model.isStudiesLoading, model.isAnalysisLoading, model.AnalysisFormComponent, model.SelectedAnalysis, model.VisualizationComponent, model.CustomReportComponent, model.CustomReportModel, model.CustomStentReportComponent, model.CustomStentReportModels, model.Credentials, model.S3Context, model.SegmentationWarningShownAfter), singleton((dispatch_45) => {
                dispatch_45(new Msg(24, [model.PatientGuid]));
            })];
        case 54:
            return [new Model(model.MaybeCurrentUser, model.Studies, model.Patients, institutions, model.PatientGuid, model.SelectedPatient, model.PatientInstitution, model.StudyGuid, model.CoreFormComponent, model.isStudiesLoading, model.isAnalysisLoading, model.AnalysisFormComponent, model.SelectedAnalysis, model.VisualizationComponent, model.CustomReportComponent, model.CustomReportModel, model.CustomStentReportComponent, model.CustomStentReportModels, model.Credentials, model.S3Context, model.SegmentationWarningShownAfter), singleton((dispatch_46) => {
                dispatch_46(new Msg(24, [model.PatientGuid]));
            })];
        case 55:
            return [model, Navigation_newUrl(Urls_pageHash(new Urls_Page(6, [new Urls_PatientPage(0, [])])))];
        case 56:
            return [new Model(model.MaybeCurrentUser, model.Studies, model.Patients, model.Institutions, model.PatientGuid, model.SelectedPatient, model.PatientInstitution, model.StudyGuid, model.CoreFormComponent, model.isStudiesLoading, false, model.AnalysisFormComponent, model.SelectedAnalysis, model.VisualizationComponent, model.CustomReportComponent, model.CustomReportModel, model.CustomStentReportComponent, model.CustomStentReportModels, model.Credentials, model.S3Context, model.SegmentationWarningShownAfter), Toast_errorToast(ErrorMessage_get_describe()(e_1))];
        case 57:
            return [model, Toast_errorToast(ErrorMessage_get_describe()(e_2))];
        case 58:
            return [model, singleton((dispatch_47) => {
                dispatch_47(new Msg(20, [model.PatientGuid]));
            })];
        case 59:
            return [model, Cmd_none()];
        default:
            return [model, (msg_111 = (new Msg(12, [wrapInboundMsg(new InboundMsg_2(3, []))])), singleton((dispatch_48) => {
                dispatch_48(msg_111);
            }))];
    }
}

